"use client";

import { c as _c } from "react/compiler-runtime";
import { ExternalLink } from "lucide-react";
import Link from "next/link";
import { useSession } from "next-auth/react";
import React, { useCallback, useContext, useEffect, useEffectEvent, useRef, useState } from "react";
import DatePickerElement from "@/app/(main)/(club)/mes-clubs/[id]/components/date-picker-element";
import EventCard from "@/app/(main)/(club)/mes-clubs/[id]/components/event-card";
import LoadingCards from "@/app/(main)/(club)/mes-clubs/[id]/components/loading-cards";
import { getAllDaysOfMonth } from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import { getClubEvents } from "@/app/api/dynabuy-back/api-events";
import { getClubEventsFromClient } from "@/app/api/dynabuy-back/client-side-api-events";
import Flash from "@/components/flash";
import ComponentLoading from "@/components/global/component-loading";
import { CardTitle } from "@/components/global/titles/card-title";
import { ClubContext } from "@/context/club-provider";
import { sidebarContext } from "@/context/sidebar-context";
import { useModalStore } from "@/stores/modal-store";
import { Club, EventRead } from "@/TS/Interfaces/global_interfaces";
import { isMember, isPresident } from "@/utils/global-utils";
import SubscribeCalendarButton from "./calendar/subscribe-calendar-button";
import EditEventModalContent from "./edit-event-modal-content";
import { ModalEventView } from "./modal-event-view";
function MonthCalender(t0) {
  const $ = _c(77);
  const {
    club,
    editable: t1,
    colorFormat,
    textColor,
    isPublic: t2
  } = t0;
  const editable = t1 === undefined ? false : t1;
  const isPublic = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = new Date();
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [date, setDate] = useState(t3);
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const [events, setEvents] = useState(t4);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const [eventArr, setEventArr] = useState(t5);
  let t6;
  if ($[3] !== eventArr) {
    t6 = eventArr.map(_temp);
    $[3] = eventArr;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const [displayEventArr, setDisplayEventArr] = useState(t6);
  let t7;
  if ($[5] !== eventArr) {
    t7 = () => {
      setDisplayEventArr(eventArr.map(_temp2));
    };
    $[5] = eventArr;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== eventArr || $[8] !== events) {
    t8 = [eventArr, events];
    $[7] = eventArr;
    $[8] = events;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  useEffect(t7, t8);
  const [isLoading, setIsLoading] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  useContext(sidebarContext);
  const {
    setFormat
  } = useContext(ClubContext);
  let t9;
  if ($[10] !== colorFormat || $[11] !== setFormat) {
    t9 = () => {
      setFormat(prev => ({
        ...prev,
        bgColor: colorFormat
      }));
    };
    $[10] = colorFormat;
    $[11] = setFormat;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const applyBgColor = useEffectEvent(t9);
  let t10;
  if ($[13] !== applyBgColor) {
    t10 = () => {
      applyBgColor();
    };
    $[13] = applyBgColor;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  useEffect(t10, t11);
  const user = useSession();
  const token = user?.data?.user?.dynabuyToken;
  const abortControllerRef = useRef(null);
  let t12;
  if ($[16] !== club || $[17] !== date) {
    t12 = async () => {
      try {
        setIsLoading(true);
        const events_0 = await getClubEvents(club.slug, new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1)));
        const arrOfEvents = events_0.map(_temp3);
        if (events_0.length === 0) {
          setEvents(null);
          setEventArr(arrOfEvents);
          setIsLoading(_temp4);
          return;
        }
        setEventArr(arrOfEvents);
        setEvents(events_0);
        setIsLoading(false);
      } catch {
        setIsLoading(_temp5);
        setEvents([]);
        setEventArr([]);
      }
    };
    $[16] = club;
    $[17] = date;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const handleFetch = t12;
  const fetchOnClubChange = useEffectEvent(handleFetch);
  let t13;
  if ($[19] !== fetchOnClubChange) {
    t13 = () => {
      fetchOnClubChange();
    };
    $[19] = fetchOnClubChange;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== club) {
    t14 = [club];
    $[21] = club;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[23] !== handleFetch || $[24] !== shouldRefresh) {
    t15 = () => {
      if (shouldRefresh) {
        handleFetch();
        setShouldRefresh(false);
      }
    };
    t16 = [shouldRefresh, handleFetch];
    $[23] = handleFetch;
    $[24] = shouldRefresh;
    $[25] = t15;
    $[26] = t16;
  } else {
    t15 = $[25];
    t16 = $[26];
  }
  useEffect(t15, t16);
  let t17;
  if ($[27] !== date) {
    t17 = getAllDaysOfMonth(date);
    $[27] = date;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const allDaysOfMonth = t17;
  let t18;
  if ($[29] !== club || $[30] !== date || $[31] !== token) {
    t18 = async increment => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const newAbortController = new AbortController();
      abortControllerRef.current = newAbortController;
      setIsLoading(_temp6);
      setDate(prev_0 => new Date(prev_0.getFullYear(), prev_0.getMonth() + increment));
      const currentDate = new Date(date.getFullYear(), date.getMonth() + increment, 2);
      try {
        const events_1 = await getClubEventsFromClient(setIsLoading, token, newAbortController.signal, club.slug, 1, currentDate);
        const arrOfEvents_0 = events_1.map(_temp7);
        if (events_1.length === 0) {
          setEvents(null);
          setEventArr(arrOfEvents_0);
          setIsLoading(_temp8);
          return;
        }
        setEventArr(arrOfEvents_0);
        setEvents(events_1);
        setIsLoading(_temp9);
      } catch {
        setEvents([]);
        setEventArr([]);
      }
    };
    $[29] = club;
    $[30] = date;
    $[31] = token;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const handleMonthDate = t18;
  let t19;
  if ($[33] !== club || $[34] !== displayEventArr || $[35] !== eventArr || $[36] !== events || $[37] !== isPublic) {
    t19 = index => {
      if (!displayEventArr.includes(index)) {
        return;
      }
      const event = eventArr.filter(t20 => {
        const {
          date: date_2,
          id
        } = t20;
        if (date_2.getDate() === index) {
          return id;
        }
      });
      const {
        type,
        clubSlug,
        startDate
      } = events.filter(res => res["@id"] === event[0].id)[0];
      const eventDate = new Date(startDate);
      const currentDate_0 = new Date();
      if (eventDate > currentDate_0) {
        useModalStore.getState().open({
          component: <ModalEventView type={type} clubSlug={clubSlug} startDate={startDate} isPublic={isPublic} publicClub={club} />,
          modalOptions: {
            loader: {
              component: <ComponentLoading />
            }
          }
        });
      } else {
        if (isPresident(club)) {
          useModalStore.getState().open({
            component: <EditEventModalContent eventProps={{
              type,
              clubSlug,
              startDate
            }} />,
            modalOptions: {
              closeOnOverlayClick: false,
              loader: {
                component: <ComponentLoading />
              }
            }
          });
        } else {
          useModalStore.getState().open({
            component: <ModalEventView type={type} clubSlug={clubSlug} startDate={startDate} />,
            modalOptions: {
              loader: {
                component: <ComponentLoading />
              }
            }
          });
        }
      }
    };
    $[33] = club;
    $[34] = displayEventArr;
    $[35] = eventArr;
    $[36] = events;
    $[37] = isPublic;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const handleEvent = t19;
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <CardTitle title={"R\xE9unions du club"} />;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== club) {
    t21 = (isPresident(club) || isMember(club)) && <Link prefetch={false} href={`/mes-clubs/${club.slug}/agenda`} className="text-primary flex gap-2 items-start">Voir le calendrier <ExternalLink /></Link>;
    $[40] = club;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21) {
    t22 = <div className="flex space-between justify-between  ">{t20}{t21}</div>;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== allDaysOfMonth || $[45] !== colorFormat || $[46] !== date || $[47] !== displayEventArr || $[48] !== eventArr || $[49] !== handleEvent || $[50] !== handleMonthDate || $[51] !== isLoading) {
    t23 = <DatePickerElement date={date} handleMonthDate={handleMonthDate} allDaysOfMonth={allDaysOfMonth} isLoading={isLoading} handleEvent={handleEvent} eventArr={eventArr} displayEventArr={displayEventArr} className="z-auto ring-0" colorFormat={colorFormat} />;
    $[44] = allDaysOfMonth;
    $[45] = colorFormat;
    $[46] = date;
    $[47] = displayEventArr;
    $[48] = eventArr;
    $[49] = handleEvent;
    $[50] = handleMonthDate;
    $[51] = isLoading;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== club || $[54] !== colorFormat || $[55] !== editable || $[56] !== eventArr || $[57] !== events || $[58] !== handleFetch || $[59] !== handleMonthDate || $[60] !== isLoading || $[61] !== isPublic || $[62] !== textColor) {
    t24 = isLoading ? <LoadingCards arr={eventArr} /> : null === events || events.length === 0 ? <Flash type="primary">Aucun évènement disponible à cette date</Flash> : events.length !== 0 && events.map(event_0 => <EventCard key={event_0["@id"]} arrOfEvents={eventArr} event={event_0} editable={editable} handleMonthDate={handleMonthDate} colorFormat={colorFormat} textColor={textColor} isPresident={isPresident(club)} handleFetch={handleFetch} setShouldRefresh={setShouldRefresh} isPublic={isPublic} club={club} />);
    $[53] = club;
    $[54] = colorFormat;
    $[55] = editable;
    $[56] = eventArr;
    $[57] = events;
    $[58] = handleFetch;
    $[59] = handleMonthDate;
    $[60] = isLoading;
    $[61] = isPublic;
    $[62] = textColor;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== t24) {
    t25 = <div className="flex flex-col gap-2 w-full">{t24}</div>;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t23 || $[67] !== t25) {
    t26 = <div className="flex flex-col gap-4  md:flex-row-reverse items-center justify-center">{t23}{t25}</div>;
    $[66] = t23;
    $[67] = t25;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== club || $[70] !== isPublic || $[71] !== user?.data) {
    t27 = !isPublic && user?.data !== null && <div className="mt-5"><SubscribeCalendarButton clubSlug={club.slug} /></div>;
    $[69] = club;
    $[70] = isPublic;
    $[71] = user?.data;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t22 || $[74] !== t26 || $[75] !== t27) {
    t28 = <div className="bg-light-grey rounded-lg p-4">{t22}{t26}{t27}</div>;
    $[73] = t22;
    $[74] = t26;
    $[75] = t27;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  return t28;
}
function _temp9(_prev_3) {
  return false;
}
function _temp8(_prev_2) {
  return false;
}
function _temp7(elem_0) {
  return {
    id: elem_0["@id"],
    date: new Date(elem_0.startDate),
    cancel: elem_0.cancel
  };
}
function _temp6(_prev_1) {
  return true;
}
function _temp5(_prev) {
  return false;
}
function _temp4(_prev_0) {
  return false;
}
function _temp3(elem) {
  return {
    id: elem["@id"],
    date: new Date(elem.startDate),
    cancel: elem.cancel
  };
}
function _temp2(t0) {
  const {
    date: date_1
  } = t0;
  return date_1.getDate();
}
function _temp(t0) {
  const {
    date: date_0
  } = t0;
  return date_0;
}
export default MonthCalender;